import { Component, ViewChild,OnInit,Input, ElementRef } from '@angular/core';
import { InterfaceElement } from '../../model/asd/asd-properties/asd-ie/asd-interfaceElement';

@Component({
  selector: 'app-html-slider',
  templateUrl: './html-slider.component.html',
  styleUrls: ['./html-slider.component.css']
})
export class HtmlSliderComponent implements OnInit {

  constructor() { }

  @Input() ieListType : InterfaceElement = new InterfaceElement();
  @ViewChild('slider') slider: ElementRef;

  public min: number = 0;
  public max: number = 0;
  public step: number = 0;
  public displayName : string = '';
  public sliderTypeID = '';
  public selected : any[] = [];
  public  tooltipdisplay : boolean = false;
  

  public someRange2config: any = {
  behaviour: 'drag',
  connect: true,
  margin: 1,
  limit: 5, // NOTE: overwritten by [limit]="10"
  range: {
    min: 0,
    max: 20
  },
  pips: {
    mode: 'steps',
    density: 5
  }
};
 someRange2 = [10,15];

 public  sliderConfig : any = {
   pips: {
    mode: 'steps',
    density: 5
  }
 }
  public onSliderChange(event){
   // console.log('Slider event: ', event);
  }

  func(){

    const connect = this.slider.nativeElement.querySelectorAll('.noUi-target');
    const classFleschIndex = ['slider-bckgd2'];
    const classWSTIndex = ['slider-bckgd1'];
    if( this.slider.nativeElement.id == 'RedToGreen'){
      for ( let i = 0; i < connect.length; i++ ) {
        connect[i].classList.add(classFleschIndex[i]);
      }
    }
    if( this.slider.nativeElement.id == 'GreenToRed'){
      for ( let i = 0; i < connect.length; i++ ) {
        connect[i].classList.add(classWSTIndex[i]);
      }
    }
  }

  ngOnInit() {
    
    if(this.ieListType.CustomizeOptions!= null && this.ieListType.CustomizeOptions.DisplayType == 'slider'){
      let headerItems = this.ieListType.EntityList.HeaderItems;
      this.min = this.ieListType.CustomizeOptions.Properties.SliderMin;
      this.max = this.ieListType.CustomizeOptions.Properties.SliderMax;
      this.step =  this.ieListType.CustomizeOptions.Properties.SliderStep;
      this.tooltipdisplay = this.ieListType.CustomizeOptions.Properties.SliderTooltipDisplay;
      this.sliderTypeID = this.ieListType.CustomizeOptions.Properties.SliderTypeID;
      if(this.ieListType.EntityList.RowItems.length > 0){

        for(let sd of this.ieListType.EntityList.RowItems[0].ColItems ){
          let dataIndex = headerItems.map(function(d) { return d['Name']; }).indexOf(sd.Name);
          this.displayName = headerItems[dataIndex].DisplayName;
          this.selected.push(sd.Value);
        }
      }  
    }
  }
  ngAfterViewInit() { 
     //this.func();
  }

}
